import { schema } from "normalizr";

export const SKUSchema = new schema.Entity(
  "skus",
  {},
  {
    idAttribute: "objectId",
  }
);
